import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function ProductShowcaseSection() {
  const categories = [{
    name: 'Olympia Trees',
    colSpan: 'md:col-span-2',
    rowSpan: 'md:row-span-2',
    image: 'https://cdn.magicpatterns.com/uploads/vowxs8L2jwX3mRs114YayJ/hf_20260422_180738_89f0d409-07cb-41e6-9142-465489141281.png'
  }, {
    name: 'Oversized Statement Décor',
    colSpan: 'md:col-span-1',
    rowSpan: 'md:row-span-1',
    image: 'https://cdn.magicpatterns.com/uploads/efVwLvQNLwrHxbfB8Ybd3D/hf_20260422_181811_8dff22f1-0c45-440b-b43f-01c44b947be2.png'
  }, {
    name: 'Signature Ornaments',
    colSpan: 'md:col-span-1',
    rowSpan: 'md:row-span-1',
    image: 'https://cdn.magicpatterns.com/uploads/rgu7Laah17S8FrmEAsbbF4/hf_20260422_182035_30be845c-53c8-4f74-ba7a-2437fa3a585f.png'
  }];
  return <section className="py-24 bg-tcp-black pt-[30px]" data-id="element-56" data-mp="3ou8gyf608x28">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-57" data-mp="1hadk6mbg88oa">
        <div className="flex flex-col md:flex-row mb-12 gap-6 items-end justify-start" data-id="element-58" data-mp="1hbyeqbxrjrm5">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-59" data-mp="1chaly0vq8b1r">
            <h2 className="font-display md:text-5xl font-bold text-white mb-4 text-[28px]" data-id="element-60" data-mp="1v9mwhawjaimz">
              Curated For Impact
            </h2>
            <p className="text-gray-400 max-w-xl text-lg" data-id="element-61" data-mp="1r6gjlkex1t7j">
              Explore our premium categories designed specifically for high-end
              retail and professional installations.
            </p>
          </motion.div>

          <motion.a href="https://wholesale.thechristmaspalace.com/pages/apply" target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} whileHover={{
          x: 5
        }} className="self-start md:self-auto flex items-center gap-2 bg-tcp-red text-white font-medium uppercase tracking-wider px-6 py-3 rounded-sm hover:bg-tcp-dark-red transition-colors duration-300 text-[12px]" data-id="element-62" data-mp="au1gk5puxylb">
            Apply For Your Wholesale Account
          </motion.a>
        </div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={{
        hidden: {
          opacity: 0
        },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.15
          }
        }
      }} className="grid grid-cols-1 md:grid-cols-3 auto-rows-[250px] gap-4" data-id="element-63" data-mp="3ks1wiumun5ff">
          {categories.map((cat, index) => <motion.div key={index} variants={{
          hidden: {
            opacity: 0,
            scale: 0.95
          },
          visible: {
            opacity: 1,
            scale: 1,
            transition: {
              duration: 0.5
            }
          }
        }} className={`relative group overflow-hidden bg-tcp-black border border-white/5 ${cat.colSpan} ${cat.rowSpan}`} data-id="element-64" data-mp="312vry6rfeows" data-mpi={index}>
              {/* Placeholder for actual images */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent z-10" data-id="element-65" data-mp="3tu5ni9qga7w9" />
              {cat.image ? <img src={cat.image} alt={cat.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-66" data-mp="1n65bgmtm9rej" /> : <>
                  <div className="absolute inset-0 bg-[#111111] group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-67" data-mp="20wsayh77blbo" />
                  {/* Subtle pattern to make placeholder less boring */}
                  <div className="absolute inset-0 opacity-5" style={{
              backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
              backgroundSize: '20px 20px'
            }} data-id="element-68" data-mp="195kpxiwbhhhc" />
                </>}

              <div className="absolute bottom-0 left-0 p-8 z-20 w-full" data-id="element-69" data-mp="2om36nk9p2piy">
                <div className="w-8 h-1 bg-tcp-red mb-4 transform origin-left group-hover:scale-x-150 transition-transform duration-300" data-id="element-70" data-mp="2tko5bf9at15a" />
                <h3 className="font-display text-2xl md:text-3xl font-semibold text-white" data-id="element-71" data-mp="33rqp7yagmfmk">
                  {cat.name}
                </h3>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}